<template>
  <main>
    <SingleLevelBreadcrumb label="Sitemap" />
    <Heading
      class="text--center"
      spaces-bottom
    >
      Sitemap
    </Heading>
    <div class="grid grid__item--l-spacing-5 grid__item--spacing-2">
      <div class="grid__item grid__item--12">
        <CategorySitemap :sitemap-data="shopSitemap.productCategories" />
      </div>
    </div>
  </main>
</template>

<script>
import { ref } from 'vue';
import fetchShopSitemap from '@/lib/goliath/shop-sitemap';
import fetchSitemapAggregationsByCategory from '@/lib/goliath/sitemap-aggregations-by-categories';

import SingleLevelBreadcrumb from '@/components/single-level-breadcrumb.vue';
import CategorySitemap from '@/components/category-sitemap.vue';
import { Heading } from '@i22-td-smarthome/component-library';
import { Track } from '~/helpers/page-tracking';
import { getHeader } from '~/helpers/page-header-compositon';

export default {
  components: {
    CategorySitemap,
    SingleLevelBreadcrumb,
    Heading,
  },
  setup() {
    Track({ page_type: 'theme.landing' });

    getHeader({
      title: ref('Überblick'),
      description: ref(
        'Alle Themen und die am häufigsten gesuchten Geräte im Überblick. Jetzt klicken und mehr erfahren!'
      ),
    });
  },
  async asyncData(context) {
    try {
      const [shopSitemapData, brandData] = await Promise.all([
        fetchShopSitemap(),
        fetchSitemapAggregationsByCategory({ category: 'smartphones-und-handys' }),
      ]);
      const brands = brandData?.aggregations?.brands || [];
      const shopSitemap = shopSitemapData?.aggregations || {};
      shopSitemap.productCategories.forEach((category) => {
        if (category.productCategory.path === 'smartphones-und-handys') {
          category.brands = brands; // eslint-disable-line no-param-reassign
        }
      });
      return {
        shopSitemap,
        brands,
      };
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return context.error({ statusCode: 404, message: 'sitemap data not found' });
      }
      return context.error({ statusCode: 500, message: error.message });
    }
  },
};
</script>
